export default __webpack_public_path__ + "static/media/Icons_Print Icon.af78fd05.svg";